const baseRouter = "/api/app/";
const baseCommonRouter = "/api/commons/";

export const ApiRouters = {
    LOGIN: baseRouter + "auths/portal-login",
    FORGOT_PASSWORD: baseRouter + "auths/forgot-password",
    CHECK_TOKEN_RESET_PW: baseRouter + "auths/check-reset-password",
    RESET_PASSWORD: baseRouter + "auths/reset-password",
    ACCOUNT: baseRouter + "accounts",

    USER_LOGIN_PROFILE: baseRouter + "accounts/my-profile",
    CHANGE_PASSWORD: baseRouter + "accounts/change-password",

    CUSTOMER: baseRouter + "customers",
    USER: baseRouter + "users",
    ROLE: baseRouter + "roles",
    PRODUCT: baseRouter + "products",
    TERRITORY: baseRouter + "territories",
    PRODUCT_TYPE: baseRouter + "product-types",
    BLOG: baseRouter + "Blogs",
    CART: baseRouter + "Cart",
    ORDER: baseRouter + "orders",
    PERMISSION: baseRouter + "permissions",
    BACKGROUND_WORKER_MANAGER: baseRouter + 'background-worker-managers',
    COMMON: {
        PROVINCES: baseCommonRouter + 'provinces',
        DISTRICT: baseCommonRouter + 'districts',
        PRICEs: baseCommonRouter + 'price-lists',
        PRODUCT_TYPE: baseCommonRouter + 'product-types',
        CALCULATION_UNIT: baseCommonRouter + 'calculation-units',
        CUSTOMER: baseCommonRouter + 'customers',
        POS_CUSTOMER_GROUPS: baseCommonRouter + 'pos/customer-groups',
        POS_EMPLOYEES: baseCommonRouter + 'pos/employees',
        VIBER_USERS: baseCommonRouter + 'viber-users',
        ZALO_USERS: baseCommonRouter + 'zalo-users',
        WAREHOUSES: baseCommonRouter + 'warehouses',
        SUPPLIERS: baseCommonRouter + 'suppliers',
    },
    REPORT: {
        COMMISSION: baseRouter + "reports/commission",
    },
    SETTING: baseRouter + 'settings',
    PARTNER: baseRouter + 'partners',
    WAREHOUSES: {
        PACKAGE_PRODUCT: baseRouter + 'package-products',
        INVENTORY: baseRouter + 'inventories',
        INVOICE_INVENTORY: baseRouter + 'invoice-inventories',
        INVENTORY_VOUCHER: baseRouter + 'inventory-vouchers',
        PURCHASE_PLAN_VOUCHER: baseRouter + 'purchase-plan-vouchers',
        INVOICE_INVOICE_INVENTORY_VOUCHER: baseRouter + 'invoice-inventory-vouchers',
    },
    VAT_INVOICE: baseRouter + 'vat-invoices',
    COLLECT_PAYMENTS: baseRouter +  'collect-payments',
    PROMOTION: baseRouter +  'promotions',
    STATIC_PAGES: baseRouter + 'static-pages',
}
